/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFunktionDropdownOptionDto } from '../../models/lexplus-funktion-dropdown-option-dto';

export interface FunktionenControllerGetAllDropdownOptionsV1$Params {
  standortIDs?: Array<number>;
  onlyAssigned?: boolean;
}

export function funktionenControllerGetAllDropdownOptionsV1(http: HttpClient, rootUrl: string, params?: FunktionenControllerGetAllDropdownOptionsV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusFunktionDropdownOptionDto>>> {
  const rb = new RequestBuilder(rootUrl, funktionenControllerGetAllDropdownOptionsV1.PATH, 'get');
  if (params) {
    rb.query('standortIDs', params.standortIDs, {});
    rb.query('onlyAssigned', params.onlyAssigned, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusFunktionDropdownOptionDto>>;
    })
  );
}

funktionenControllerGetAllDropdownOptionsV1.PATH = '/v1/funktionen/dropdown-options';
